import { useState } from 'react';
import { ButtonSecondary, ButtonPseudo, ButtonSize, Textarea } from '@ui/src';
import CommentItem from './comment-item';
import { ProcessingResultTypes } from './types';

import cn from './styles.module.css';

const ProcessingResult = ({
  comments,
  onCommentSend,
  sendCommentInProgress,
  textareaIsVisible,
  setTextareaIsVisible,
  applicationId,
}: ProcessingResultTypes) => {
  const [value, setValue] = useState('');

  const onSend = () => {
    onCommentSend(value);

    setValue('');
  };

  let content;

  if (!textareaIsVisible) {
    content = (
      <ButtonSecondary
        text="Add comment"
        onClick={() => setTextareaIsVisible(true)}
        size={ButtonSize.SMALL}
        className={cn.showTextareaButton}
      />
    );
  } else {
    content = (
      <>
        <Textarea
          name="comment"
          placeholder="Enter comment here..."
          onChange={(e) => setValue(e.target.value)}
          value={value}
        />
        <div className={cn.processingResultCommentControls}>
          <ButtonSecondary
            text={sendCommentInProgress ? 'Loading...' : 'Save Comment'}
            onClick={onSend}
            className={`button-white ${cn.sendCommentButton}`}
            size={ButtonSize.SMALL}
          />
          <ButtonPseudo
            text="Cancel"
            onClick={() => setTextareaIsVisible(false)}
            size={ButtonSize.SMALL}
          />
        </div>
      </>
    );
  }

  return (
    <div className={cn.processingResult}>
      <div className={cn.proessingResultTitle}>Processing result</div>
      {content}
      {comments?.length > 0 &&
        comments.map((comment) => (
          <CommentItem
            key={comment.id}
            comment={comment}
            applicationId={applicationId}
          />
        ))}
    </div>
  );
};

export default ProcessingResult;
